export const showErrorMessage = (error: unknown): void => {
  alert("予期せぬエラーが発生しました。時間を置いて再度お試しください。");
  console.error(error);
};
